/**
 * SpendTrendChart — Recharts line chart of daily/monthly AI spend (P3). The
 * canvas is decorative (`role="img"` + `aria-label`); the authoritative data is
 * mirrored in an `sr-only` table so screen readers and axe have real content.
 */
import { type ReactElement } from "react";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { SpendTrendPoint } from "@/features/admin/ai-usage/api";

export function SpendTrendChart({ points, label }: { points: SpendTrendPoint[]; label: string }): ReactElement {
  return (
    <figure role="img" aria-label={label} className="w-full">
      <div className="h-64 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 8, right: 8, bottom: 8, left: 8 }}>
            <XAxis dataKey="bucket" stroke="var(--g-secondary)" fontSize={12} />
            <YAxis stroke="var(--g-secondary)" fontSize={12} />
            <Tooltip />
            <Line type="monotone" dataKey="cost_usd" stroke="var(--g-primary)" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <table className="sr-only">
        <caption>{label}</caption>
        <thead><tr><th>bucket</th><th>cost_usd</th><th>tokens</th></tr></thead>
        <tbody>
          {points.map((p) => (
            <tr key={p.bucket}><td>{p.bucket}</td><td>{p.cost_usd}</td><td>{p.tokens}</td></tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}
export default SpendTrendChart;
